/* eslint-disable array-bracket-newline */
/* eslint-disable nonblock-statement-body-position */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import useJwt from '@src/auth/jwt/useJwt'
import { employeeEditAdapter } from '../wizard-edit/adapters'

export const getAllData = createAsyncThunk(
  'appUsers/getAllData',
  async () => {
    const response = await axios.get('/api/lots/list/all-lots')
    return response.data
  }
)

export const getAllBatchId = createAsyncThunk(
  'getAllBatchId/GET',
  async () => {
    const response = await useJwt.getAllBatches()

    return response.data.map((batch) => ({
      label: String(`${batch.id}`),
      value: batch.id,
      approved: batch.approved,
    }))
  }
)

export const addEmployee = createAsyncThunk(
  'addEmployee/POST',
  async (params) => {
    try {
      const response = await useJwt.addEmployee(params)
      return response.data
    } catch (error) {
      // console.log('error', error)
      return error
    }
  }
)

export const editEmployee = createAsyncThunk(
  'editEmployee/PUT',
  async (params) => {
    // console.log('params', params)

    try {
      const employee = employeeEditAdapter(params)
      const response = await useJwt.editEmployee(employee)
      return response.data
    } catch (error) {
      return error
    }
  }
)

export const getBatchChildId = createAsyncThunk(
  'getBatchChildId/GET',
  async (batchID) => {
    // ? Obtener el id del sublote disponible
    const response = await useJwt.getBatchChildId(batchID)
    return response.data
  }
)

export const getData = createAsyncThunk(
  'appUsers/getData',
  async (params) => {
    const response = await axios.get('/api/users/list/data', params)
    return {
      params,
      data: response.data.users,
      totalPages: response.data.total,
    }
  }
)

export const getUser = createAsyncThunk('appUsers/getUser', async (id) => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk(
  'appUsers/addUser',
  async (user, { dispatch, getState }) => {
    await axios.post('/apps/users/add-user', user)
    await dispatch(getData(getState().users.params))
    await dispatch(getAllData())
    return user
  }
)

export const deleteUser = createAsyncThunk(
  'appUsers/deleteUser',
  async (id, { dispatch, getState }) => {
    await axios.delete('/apps/users/delete', { id })
    await dispatch(getData(getState().users.params))
    await dispatch(getAllData())
    return id
  }
)

export const approvaldBatch = createAsyncThunk(
  'approvaldBatch/PUT',
  async (selectedBatchId) => {
    const response = await useJwt.approvaldBatch(selectedBatchId)
    return response.data
  }
)

const getCatalogData = async (endpoint) => {
  const response = await useJwt.getCatalog(endpoint)
  return response
}

export const getCatalogAddress = createAsyncThunk(
  'getCatalogAddress',
  async () => {
    const response = await getCatalogData('catalog-address')
    const listCatalog = response?.data?.map((typeAddres) => ({
      label: typeAddres,
      value: typeAddres,
    }))
    return listCatalog
  }
)

const searchDepartment = (nameDepartment, departments) => {
  const result = departments?.find(
    (dep) => String(dep.value).toLocaleUpperCase() === nameDepartment
  )
  return result
}

export const getEmployeeById = createAsyncThunk(
  'getEmployeeById',
  async (id) => {
    const response = await useJwt.getEmployeeById(id)
    return response.data
  }
)

export const appEmployeesSlice = createSlice({
  name: 'appEmployees',
  initialState: {
    data: {},
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    allBatchID: [],
    batchChildID: 0,
    sendForm: {},
    parentesco: {
      relationship1: [],
      relationship2: [],
      relationshi3: [],
      relationship4: [],
    },
    'catalog-address': [],
    personalinformation: {
      departmentselected: [],
      municipalities: [],
      selectMunicipality: [],
    },
    identification: {
      departmentselected: [],
      municipalities: [],
      selectMunicipality: [],
    },
    identificationPlaceExpeditionDui: {
      departmentselected: [],
      municipalities: [],
      selectMunicipality: [],
    },
    mainaddress: {
      departmentselected: [],
      municipalities: [],
      selectMunicipality: [],
    },
    labordata: {
      departmentselected: [],
      municipalities: [],
      selectMunicipality: [],
    },
    economicdata: {
      departmentselected: [],
      municipalities: [],
      selectMunicipality: [],
    },
  },
  reducers: {
    saveDataTemp: (state, action) => {
      state.sendForm = {
        ...state.sendForm,
        ...action.payload,
      }
    },
    setInitialDataTemp: (state) => {
      state.sendForm = {}
      state.batchChildID = 0
    },
    loadMunicipalitiesByNameDeparment: (state, action) => {
      const { nameState, departments, nameDepartment } = action.payload
      if (!nameState || !(departments.length > 0) || !nameDepartment)
        return
      const departament = searchDepartment(nameDepartment, departments)
      const test = {
        nameState,
        departments,
        nameDepartment,
        departament,
      }
      // console.log(test)
      state[nameState].municipalities = departament?.municipios
    },
    loadValueDepartment: (state, action) => {
      const { nameState, departmentselected: dep } = action.payload
      // console.log('loadValueDepartment', nameState, dep);
      state[nameState].departmentselected = [dep]
    },
    loadValueMunicipality: (state, action) => {
      const { nameState, municipality } = action.payload
      state[nameState].selectMunicipality = [
        { label: municipality, value: municipality },
      ]
    },
    clearValueMunicipality: (state, action) => {
      const nameState = action.payload
      state[nameState].selectMunicipality = []
    },
    loadDataEmployee: (state, action) => {
      const { data } = action.payload
      state.data = data
    },
    setParentesco: (state, action) => {
      const { nameState, parentesco } = action.payload
      const { relationship1, relationship2, relationshi3, relationship4 } =
        parentesco
      state[nameState].relationship1 = [
        { label: relationship1, value: relationship1 },
      ]
      state[nameState].relationship2 = [
        { label: relationship2, value: relationship2 },
      ]
      state[nameState].relationshi3 = [
        { label: relationshi3, value: relationshi3 },
      ]
      state[nameState].relationship4 = [
        { label: relationship4, value: relationship4 },
      ]
    },
    handleChangeParentesco: (state, action) => {
      console.log(Object.keys(action.payload))
      const { nameState } = action.payload
      const parentesco = Object.keys(action.payload)[1]
      state[nameState] = {
        ...state[nameState],
        [parentesco]: [
          {
            label: action.payload[parentesco],
            value: action.payload[parentesco],
          },
        ],
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      .addCase(getAllBatchId.fulfilled, (state, action) => {
        state.allBatchID = action.payload
      })
      .addCase(getBatchChildId.fulfilled, (state, action) => {
        state.batchChildID = action.payload
      })
      .addCase(getBatchChildId.rejected, (state, action) => {
        state.batchChildID = 0
      })
      .addCase(getCatalogAddress.fulfilled, (state, action) => {
        state['catalog-address'] = action.payload
      })
      .addCase(getEmployeeById.fulfilled, (state, action) => {
        state.data = action.payload
      })
  },
})

export const {
  saveDataTemp,
  setParentesco,
  handleChangeParentesco,
  loadDataEmployee,
  clearValueMunicipality,
  loadMunicipalitiesByNameDeparment,
  loadValueDepartment,
  loadValueMunicipality,
  setInitialDataTemp,
} = appEmployeesSlice.actions

export default appEmployeesSlice.reducer
